<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h2 class="CH1_Chapter_title_1 ParaOverride-1" id="_idParaDest-3"><span class="CharOverride-3">CHRISTOPHER</span></h2>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-4">BR</span><span class="CharOverride-4">OO</span><span class="CharOverride-4">K</span><span class="CharOverride-4">M</span><span class="CharOverride-4">Y</span><span class="CharOverride-4">R</span><span class="CharOverride-4">E</span></p>
<p class="Basic-Paragraph ParaOverride-4"><span class="CharOverride-5">B</span><span class="CharOverride-5">L</span><span class="CharOverride-5">ACK</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-5">WI</span><span class="CharOverride-5">D</span><span class="CharOverride-5">OW</span></p>
<p class="BT1_Body_text_1_Full-out ParaOverride-5"><img alt="" class="_idGenObjectAttribute-1" src="image/L-1.png"/></p>
<p class="BT1_Body_text_1_Full-out ParaOverride-3">Atlantic Monthly Press</p>
<p class="BT1_Body_text_1_Full-out ParaOverride-3"><span class="CharOverride-6">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RR0208-2.vue?76f23949